import React from 'react';

import LatestProducts from '../components/LatestProducts.js';
import BrandsParallax from '../components/BrandsParallax.jsx';
import HeroBanner from '../components/HeroBanner.jsx';
import AboutBlock from '../components/AboutBlock.jsx';
import FAQ from '../components/FAQ.jsx';
import ContactBlock from '../components/ContactBlock.jsx';

const Home = () => {
  return (
    <section>
      {/*<Hero />*/}
      <HeroBanner />
      <LatestProducts />
      <BrandsParallax />
      <AboutBlock />
      <FAQ />
      <ContactBlock />
    </section>
  );
};

export default Home;
